import { render } from "./MemorialAdminsPage.vue?vue&type=template&id=dd36875e&scoped=true"
import script from "./MemorialAdminsPage.vue?vue&type=script&lang=js"
export * from "./MemorialAdminsPage.vue?vue&type=script&lang=js"

import "./MemorialAdminsPage.vue?vue&type=style&index=0&id=dd36875e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd36875e"]])

export default __exports__